<template>
    <v-card class="pa-5" :style="$vuetify.breakpoint.smAndUp ? 'width:480px' : ''">
        <v-form @submit.prevent>
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('change_password')" aria-hidden="true" translate="no">close</v-icon>
            <v-card-title class="display-1 mb-2">{{ $t("Изменить пароль") }}</v-card-title>
            <v-layout style="display: block" column>
                <v-flex md4 mb-4>
                    <div class="grey-text mb-2">{{ $t("Введите старый пароль") }}</div>
                    <passInput v-model.trim.lazy="old_pass" :v="$v.old_pass"
                               @change="get_old_pass($event.target.value)"
                    />
                </v-flex>
                <v-flex md4 mb-4>
                    <div class="grey-text mb-2">{{ $t("Введите новый пароль") }}</div>
                    <passInput v-model.trim.lazy="new_pass" :v="$v.new_pass"
                               @change="get_new_pass($event.target.value)"
                    />
                </v-flex>
                <v-flex md4 mb-4>
                    <div class="grey-text mb-2">{{ $t("Введите новый пароль") }} еще раз</div>
                    <passInput v-model.trim.lazy="new_pass_confirm" :v="$v.new_pass_confirm"
                               @change="get_new_pass_confirm($event.target.value)"
                    />
                </v-flex>
            </v-layout>
            <div class="red-text">{{ error_message }}</div>
            <v-card-actions class="mt-4">
                <buttonRed @click.native="check_validation()">{{ $t("Применить") }}</buttonRed>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {required, minLength, helpers, sameAs} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import buttonRed from '@/components/ui/buttons/button_red';
import passInput from '@/components/blocks/forms/password_input';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    passInput,
  },
  mixins: [validationMixin],
  props : {
    modal_type: {
      type: Object,
    },
  },
  validations: {
    old_pass: {
      required,
      minLength: minLength(6),
    },
    new_pass: {
      required,
      password: (value) => {
        return /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*\-._]/.test(value);
      },
      minLength: minLength(10),
    },
    new_pass_confirm: {
      required,
      password: (value) => {
        return /[a-z]/.test(value) && /[A-Z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*\-._]/.test(value);
      },
      minLength   : minLength(10),
      confirm_pass: sameAs('new_pass'),
    },
  },
  data() {
    return {
      password: {
        old_password    : '',
        new_password    : '',
        confirm_password: '',
      },
      old_pass        : '',
      new_pass        : '',
      new_pass_confirm: '',
      errors          : false,
    };
  },
  computed: {
    ...mapGetters('profile/modals', [
      'change_password',
    ]),
    ...mapGetters('profile/user', [
      'error_message',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapActions('profile/user', [
      'change_pass',
    ]),
    ...mapMutations('profile/modals', [
      'CLOSE_MODAL',
    ]),
    ...mapMutations('profile/user', [
      'SET_ERROR',
    ]),
    get_old_pass(ev) {
      this.$v.old_pass.$touch();
      this.SET_ERROR('');
      this.password.old_password = ev;
    },
    get_new_pass(ev) {
      this.$v.new_pass.$touch();
      this.password.new_password = ev;
    },
    get_new_pass_confirm(ev) {
      this.$v.new_pass_confirm.$touch();
      this.password.confirm_password = ev;
    },
    check_validation() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.change_pass(this.password);
        this.errors = false;
        this.clear();
      }
    },
    clear() {
      this.$v.$reset();
      this.old_pass = '';
      this.new_pass = '';
      this.new_pass_confirm = '';
    },
  },

};
</script>
